import '../src/animate/index';



/** WEBPACK FOOTER **
 ** ./examples/animate.js
 **/